import client from "../api/client";
export const getList = () => {
  return client('/api/buildings').then(({ data }) => data.data);
};

export const getPortfolio = () => {
  return client('/api/buildings/portfolio').then(({ data }) => data.data);
};

export const getDetail = (id) => {
  return client(`/api/buildings/${id}`).then(({ data }) => data.data);
};

export const getPortfolioDetail = (id) => {
  return client(`/api/buildings/portfolio/${id}`).then(({ data }) => data.data);
};

export const addEditModel = (values= {}, id=null) => {
  if (id){
    return client(`/api/buildings/${id}`, {method: 'put', body: values}).then(({ data }) => data.data);
  } else {
    return client('/api/buildings', {method: 'post', body: values}).then(({ data }) => data.data);
  }
};

export const delModel = (id) => {
    return client(`/api/buildings/${id}`, {method: 'delete'}).then(({ data }) => data.data);
};

export function useBuildingService () {
  return {
    getList,
    getPortfolio,
    getPortfolioDetail,
    addEditModel,
    getDetail,
    delModel,
  };
}
